import axios from "axios";
import { environment } from "../enviroments/enviroment.js";
import { errorBox } from "../store/stores.js";

const apiUrl = environment.apiUrl;

function saveAccessTokenToStore(token) {
  localStorage.setItem("accessToken", token);
}

function saveRefreshTokenToStore(token) {
  localStorage.setItem("refreshToken", token);
}

export const getAccessToken = async (accessCode) => {
  const accessInfo = await axios
    .post(
      `${apiUrl}/token?grant_type=authorization_code&code=${accessCode}&redirect_uri=${environment.redirectUrl}`,
      { apiKey: "duzds4Tu4x219fXeco1n" },
      {
        headers: {
          apiKey: "duzds4Tu4x219fXeco1n",
        },
      }
    )
    .then((response) => {
      saveAccessTokenToStore(response.data.access_token);
      saveRefreshTokenToStore(response.data.refresh_token);
      return response.data;
    })
    .catch(() => {
      errorBox.set({
        title: "general.login-error-title",
        description: "general.login-error-description",
      });
      return false;
    });

  return Promise.resolve(accessInfo);
};

export const getUserInfo = async () => {
  const accessTokenFromStorage = localStorage.getItem("accessToken");
  const userData = await axios
    .get(`${apiUrl}/userinfo`, {
      headers: {
        Authorization: `Bearer ${accessTokenFromStorage}`,
      },
    })
    .then((response) => {
      return response.data[
        "https://oneportal.trivore.com/claims/active_external_permissions"
      ];
    })
    .catch(() => {
      return false;
    });
  return Promise.resolve(userData);
};
